import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import LegalDocs from '../bigProjects/LegalDocs';

async function action({ store, largeProjectsEnabled }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  // LARGE PROJECTS FLAG: when OFF this admin LP route is unreachable -> redirect
  // home (additive guard; non-LP admin routes untouched). Flag read from the
  // router context (server-only DB read in server.js / SSR-seeded runtime on
  // client); fail-closed at the source.
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }

  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title: 'Legal Documents — Big Projects',
    component: (
      <AdminLayout>
        <LegalDocs />
      </AdminLayout>
    ),
  };
}

export default action;
